import '@/styles/index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/app/App';
import { applyTheme } from '@/lib/theme';
import { useSettingsStore } from '@/stores/settings-store';

// Apply the persisted theme before the first paint to avoid a flash.
applyTheme(useSettingsStore.getState().theme);

const container = document.getElementById('root');
if (!container) throw new Error('FlowShare root element is missing');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
